import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import {
  switchMap,
  map,
  startWith,
  catchError,
  filter,
  tap,
} from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';
import { Position, Toaster, Intent } from '@blueprintjs/core';

import {
  WorkspaceConfigActions,
  WorkspaceConfigActionTypes,
  updatedWorkspaceConfig,
  updatingWorkspaceConfig,
  updatingWorkspaceConfigFailed,
  loadedCurrentWorkspaceConfig,
  loadingCurrentWorkspaceConfig,
  loadingCurrentWorkspaceConfigFailed,
} from '../actions/workspaceConfigActions';

import { IState } from '../reducers';
import {
  updateWorkspaceConfig,
  loadCurrentWorkspaceConfig
} from '../../services/workspaceConfigApi';

const workspaceConfigToaster= Toaster.create({
  className: 'workspace-config-toaster',
  position: Position.TOP
});

const updateWorkspaceConfigEpic: Epic<WorkspaceConfigActions, WorkspaceConfigActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(WorkspaceConfigActionTypes.UPDATE_WORKSPACE_CONFIG)),
    switchMap((action: any) =>
      from(updateWorkspaceConfig(action.payload.name, action.payload.value, action.payload.type)).pipe(
        tap((response: any) => {
          const message = "Successfully updated workspace config.";
          workspaceConfigToaster.show({
            message: message,
            intent: Intent.SUCCESS
          });
        }),
        map((response: any) => {
          return updatedWorkspaceConfig(response.result);
        }),
        startWith(updatingWorkspaceConfig()),
        catchError(() => {
          workspaceConfigToaster.show({
            message: "An error occurs when updating workspace config.",
            intent: Intent.DANGER
          });
          return of(updatingWorkspaceConfigFailed());
        })
      )
    )
  );

export const loadCurrentWorkspaceConfigEpic: Epic<WorkspaceConfigActions, WorkspaceConfigActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(WorkspaceConfigActionTypes.LOAD_CURRENT_WORKSPACE_CONFIG)),
    switchMap(() =>
      from(loadCurrentWorkspaceConfig()).pipe(
        map((response: any) => {
          return loadedCurrentWorkspaceConfig(response.result);
        }),
        startWith(loadingCurrentWorkspaceConfig()),
        catchError(() => {
          workspaceConfigToaster.show({
            message: "An error occurs when loading current workspace config.",
            intent: Intent.DANGER
          });
          return of(loadingCurrentWorkspaceConfigFailed());
        })
      )
    )
  );

export default combineEpics(
  updateWorkspaceConfigEpic,
  loadCurrentWorkspaceConfigEpic
);
